import { css } from 'styled-components';

// 響應式斷點定義
export const BREAKPOINTS = {
    tablet: 768,
    md: 640,
    sm: 480,
    xs: 360
};

/**
 * 產生 responsive 的正方形（同時設定 width / height）
 *
 * 使用方式：
 *   ${responsiveSquare({
 *     base: 500,
 *     tablet: 400,
 *     md: 350,
 *     sm: 320,
 *     xs: 280
 *   })}
 */
export const responsiveSquare = ({
    base,
    tablet,
    md,
    sm,
    xs
}) => css`
    width: ${base}px;
    height: ${base}px;

    ${tablet && css`
        @media (max-width: ${BREAKPOINTS.tablet}px) {
            width: ${tablet}px;
            height: ${tablet}px;
        }
    `}

    ${md && css`
        @media (max-width: ${BREAKPOINTS.md}px) {
            width: ${md}px;
            height: ${md}px;
        }
    `}

    ${sm && css`
        @media (max-width: ${BREAKPOINTS.sm}px) {
            width: ${sm}px;
            height: ${sm}px;
        }
    `}

    ${xs && css`
        @media (max-width: ${BREAKPOINTS.xs}px) {
            width: ${xs}px;
            height: ${xs}px;
        }
    `}
`;

/**
 * 產生 responsive 的 CSS 屬性（通用函數）
 * RWDorable = RWD (Responsive Web Design) + adorable ✨
 * 可愛又實用的響應式工具，讓你的 CSS 屬性在不同螢幕尺寸下自動適應調整
 *
 * 使用方式：
 *   // 數字值（自動添加 px）
 *   ${rwdorable('height', {
 *     base: 500,
 *     tablet: 400,
 *     md: 350,
 *     sm: 320,
 *     xs: 280
 *   })}
 *
 *   ${rwdorable('width', {
 *     base: 100,
 *     tablet: 80
 *   })}
 *
 *   // 字符串值（不添加 px，適用於 transform、margin 等需要完整 CSS 值的屬性）
 *   ${rwdorable('transform', {
 *     base: 'translateX(calc(50% + 50px))',
 *     tablet: 'translateX(calc(50% + 25px))',
 *     md: 'translateX(calc(50% + 20px))',
 *     sm: 'translateX(calc(50% + 10px))'
 *   })}
 *
 *   ${rwdorable('margin', {
 *     base: '20px 0',
 *     tablet: '15px 0',
 *     md: '12px 0',
 *     sm: '10px 0'
 *   })}
 */
export const rwdorable = (
    property,
    {
        base,
        tablet,
        md,
        sm,
        xs
    }
) => {
    // 判斷值是否為字符串，如果是字符串就不添加 px
    const formatValue = (value) => {
        if (value === undefined || value === null) return '';
        if (typeof value === 'string') return value;
        return `${value}px`;
    };

    return css`
        ${property}: ${formatValue(base)};

        ${tablet && css`
            @media (max-width: ${BREAKPOINTS.tablet}px) {
                ${property}: ${formatValue(tablet)};
            }
        `}

        ${md && css`
            @media (max-width: ${BREAKPOINTS.md}px) {
                ${property}: ${formatValue(md)};
            }
        `}

        ${sm && css`
            @media (max-width: ${BREAKPOINTS.sm}px) {
                ${property}: ${formatValue(sm)};
            }
        `}

        ${xs && css`
            @media (max-width: ${BREAKPOINTS.xs}px) {
                ${property}: ${formatValue(xs)};
            }
        `}
    `;
};

/**
 * 產生 responsive 的 height（便捷函數）
 *
 * 使用方式：
 *   ${rwdorableHeight({
 *     base: 500,
 *     tablet: 400,
 *     md: 350,
 *     sm: 320,
 *     xs: 280
 *   })}
 */
export const rwdorableHeight = (values) => rwdorable('height', values);


